export default __webpack_public_path__ + "static/media/MobileNumberUpdationThroughDDOLogin.08b0a94a.pdf";